module.exports = __webpack_public_path__ + "img/bell.687ab1b0.svg";